import availSlice from './slices/availability';

export default {
    ...availSlice.actions,
};
